import ActiveFieldIndicator from './util/ActiveFieldIndicator';

function init() {
  /* After a failed submission or a page-change, we need to re-init gravity forms.
   * Note: I tried document.addEventListener, but it doesn't get called, so we're relying on jQuery here.
   */ 
  const $ = window.jQuery && window.jQuery(window);
  if (!$) { return; }
  
  $.on('gform_post_render', initFields);
  initFields();
}

// TODO: Add this to Forms for generic inlineLabelFields.
function initFields() {
  // Add empty option to each select
  document.querySelectorAll('.inlineLabelField select').forEach(dropdown => {
    if (dropdown.nstHasEmptyField) { return; }
  
    const emptyOption = document.createElement('option');
    emptyOption.value = '';
    emptyOption.disabled = true;

    emptyOption.setAttribute('data-show-as-inactive', '');
    dropdown.nstHasEmptyField = true;
    dropdown.add(emptyOption, 0);
    dropdown.selectedIndex = 0;
  });
}

export default { init };